const Customer = () => {
  return <div>Клієнти</div>;
};

export default Customer;
